/**
* 左边菜单
*/
<template>


        <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo"  text-color="#fff" active-text-color="#ffd04b">


        <div class="logobox">
          <img class="logoimg" src="../assets/img/logo.png" alt="">
        </div>
      <el-submenu v-for="menu in allmenu" :key="menu.id" :index="menu.name">
        <template slot="title">
          <i   :class="menu.icon"></i>
          <span>{{menu.name}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="chmenu in menu.childList" :index="'/'+chmenu.url" :key="chmenu.id">
            <i   :class="chmenu.icon"></i>
            <span>{{chmenu.name}}</span>
          </el-menu-item>

        </el-menu-item-group>
      </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    menu()
      .then(res => {
        //alert('恭喜您遇到bug')
        if (res.code == 0) {
          this.allmenu = res.data
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
      .catch(err => {
        this.$message.error('菜单加载失败，请稍后再试！')
      })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-vertical-demo {
  border-right: 0 !important;
  border-radius: 5px!important;
  background-image: linear-gradient( 135deg, #334157   ,#2424a3    ) !important;
  height:100%;
  font-weight: bold;
}
.el-menu-vertical-demo .el-menu-item-group
{
  background-image: linear-gradient( 135deg, #334157   ,#2424a3    ) !important;
}

.logobox {
  background: #ffff00;
  text-align: center;
  padding: 13px 0px;
  border: none;
  background-image: linear-gradient( to right,  #f2f8fe,#03e1d1 ) !important;
}
.logoimg {
  height: 30px;
}




.el-menu-item.is-active {
  font-weight: 900!important;
  font-size: 20px!important;

}






</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue